import React, { useState } from 'react';
import { Box, Fade, Button, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchForm from '../../components/SearchForm/SearchForm';
import EmployeeDetails from '../../components/EmployeeDetails/EmployeeDetails';
import { useNavigate } from 'react-router-dom';

const SearchPage: React.FC = () => {
  const [employeeData, setEmployeeData] = useState<any>(null);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleEmployeeFound = (data: any) => {
    setEmployeeData(data);
    localStorage.setItem('servidorData', JSON.stringify(data.servidor));
  };

  const handleRequestDocument = () => {
    navigate('/validar-email', { state: { servidorData: employeeData } });
  };

  // Redireciona para a página de documentos (acesso via CPF + código)
  const handleGoToDocuments = () => {
    navigate('/documentos');
  };

  const handleBack = () => {
    if (employeeData) {
      setEmployeeData(null);
    } else {
      navigate('/');
    }
  };

  return (
    <Box>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={handleBack}
        sx={{ mb: 2, color: theme.palette.text.secondary }}
      >
        Voltar
      </Button>

      <Fade in={true} timeout={500}>
        <Box>
          {!employeeData ? (
            <SearchForm onEmployeeFound={handleEmployeeFound} />
          ) : (
            <EmployeeDetails 
              data={employeeData}
              onRequestDocument={handleRequestDocument}
              onGoToDocuments={handleGoToDocuments}
            />
          )}
        </Box>
      </Fade>
    </Box>
  );
};

export default SearchPage;